import React from 'react';
import { FiCheck, FiMaximize2 } from 'react-icons/fi';

export default function Section({ section }) {
  return (
    <section className="doc-section" id={section.id}>
      <div className="doc-copy">
        <span className="section-label">{section.eyebrow}</span>
        <h2>{section.title}</h2>
        <p className="doc-description">{section.description}</p>
        <ul className="doc-list">
          {section.bullets.map((item) => <li key={item}><FiCheck aria-hidden="true" /><span>{item}</span></li>)}
        </ul>
        {section.note && <div className="rule-example"><small>Example rule</small><code>{section.note}</code></div>}
      </div>
      <div className={`doc-gallery${section.images.length > 1 ? ' doc-gallery-pair' : ''}`}>
        {section.images.map((image) => (
          <figure className="screenshot-card" key={image.src}>
            <a href={image.src} target="_blank" rel="noopener noreferrer" aria-label={`Open full-size image: ${image.alt}`}>
              <img src={image.src} alt={image.alt} loading="lazy" />
              <span className="image-zoom"><FiMaximize2 aria-hidden="true" /> Full size</span>
            </a>
            <figcaption>{image.caption}</figcaption>
          </figure>
        ))}
      </div>
    </section>
  )
}
